/* ============================================
   EVENFLOW WORLDWIDE — THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  var hamburger = document.querySelector('.hamburger');
  var mobileNav = document.querySelector('.mobile-nav');
  var mobileClose = document.querySelector('.mobile-nav__close');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // Accordion
  document.querySelectorAll('.accordion__header').forEach(function (header) {
    header.addEventListener('click', function () {
      var item = this.closest('.accordion__item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion__item').forEach(function (i) {
        i.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });

  // Size selector
  document.querySelectorAll('.size-btn:not(.sold-out)').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grid = this.closest('.size-grid');
      grid.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // Color swatches
  document.querySelectorAll('.color-swatch').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var row = this.closest('.color-swatches');
      row.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // Qty selector
  document.querySelectorAll('.qty-selector').forEach(function (sel) {
    var val = sel.querySelector('.qty-selector__val');
    sel.querySelector('.qty-selector__btn--minus').addEventListener('click', function () {
      var n = parseInt(val.textContent);
      if (n > 1) val.textContent = n - 1;
    });
    sel.querySelector('.qty-selector__btn--plus').addEventListener('click', function () {
      val.textContent = parseInt(val.textContent) + 1;
    });
  });

  // Gallery thumbs
  document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var gallery = this.closest('.product-gallery');
      gallery.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
      var mainImg = gallery.querySelector('.product-gallery__main img');
      var thumbImg = this.querySelector('img');
      if (mainImg && thumbImg) mainImg.src = thumbImg.src;
    });
  });

  // Filter drawer
  var filterBtn = document.querySelector('.filter-btn');
  var filterDrawer = document.querySelector('.filter-drawer');
  if (filterBtn && filterDrawer) {
    filterBtn.addEventListener('click', function () {
      filterDrawer.classList.toggle('open');
      filterBtn.classList.toggle('active');
    });
  }

  // Filter checkboxes
  document.querySelectorAll('.filter-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      var chk = this.querySelector('.filter-check');
      chk.classList.toggle('checked');
    });
  });

  // Collection tabs
  document.querySelectorAll('.collection-tab').forEach(function (tab) {
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelectorAll('.collection-tab').forEach(function (t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // Cart: add to cart button feedback
  var atcBtn = document.querySelector('.btn-atc');
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      var original = this.textContent;
      this.textContent = 'Added!';
      this.style.background = '#4ade80';
      this.style.color = '#0a1a0f';
      var self = this;
      setTimeout(function () {
        self.textContent = original;
        self.style.background = '';
        self.style.color = '';
      }, 1800);
    });
  }

  // Email form
  var emailForm = document.querySelector('.email-form');
  if (emailForm) {
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = this.querySelector('button');
      var input = this.querySelector('input');
      if (input.value) {
        btn.textContent = 'Subscribed!';
        input.value = '';
        setTimeout(function () { btn.textContent = 'Subscribe'; }, 2500);
      }
    });
  }

  // Active nav link
  var path = window.location.pathname;
  document.querySelectorAll('.site-header__nav a, .mobile-nav__links a').forEach(function (link) {
    if (link.getAttribute('href') === path) link.classList.add('active');
  });

});
